import { faFaceThinking } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Stack } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PortalLink from '../../common/PortalLink';

const SpecialAccessRequired = ({ message, link }) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const resolvedLink =
    link ||
    (state?.link && (
      <PortalLink href={state.link} target="_blank">
        {state?.title || 'Go to the requested page'}
      </PortalLink>
    ));

  const defaultMessage = resolvedLink
    ? 'The link below requires special access.'
    : 'The requested page requires special access.';

  const resolvedMessage = message || state?.message || defaultMessage;

  return (
    <Stack alignItems={'center'}>
      <FontAwesomeIcon icon={faFaceThinking} fixedWidth size="6x" />
      <Typography component="h2" className="myOdu__errorCode">
        Special Access Required
      </Typography>
      <Typography component="p" className="myOdu__errorCode">
        {resolvedMessage} If you are unable to access the requested page, contact the{' '}
        <PortalLink
          href="https://oduprod.service-now.com/sp"
          target="_blank"
          ariaLabel="IT Help Desk"
        >
          IT Help Desk
        </PortalLink>{' '}
        for access support.
      </Typography>
      <Stack sx={{ mt: 2 }}>
        {resolvedLink || (
          <PortalLink
            href="#"
            className="noIcon"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            Go Back
          </PortalLink>
        )}
      </Stack>
    </Stack>
  );
};

export default SpecialAccessRequired;
